import ReferencePathService from '~/services/referencePathServices/referencePathService'
import {
  IReferencePathNodeApiHeader,
  IReferencePathNodeSpecific
} from '~/interfaces/referencePathInterfaces'
import {GenericType} from '~/interfaces/genericTypeInterfaces'
import {ModelType} from '~/enums/modelType'

export default class ApiHeaderPathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.Text

  constructor(private apiHeaderNode: IReferencePathNodeApiHeader) {
    super()
  }

  get label(): string {
    return this.apiHeaderNode.reference()?.key
  }

  get nodes(): IReferencePathNodeApiHeader[] {
    return [this.apiHeaderNode]
  }

  reference() {
    return this.apiHeaderNode.parent.nodes[this.apiHeaderNode.parent.nodes.length - 2].reference().allLiveHeaders.find(header => header.id === this.apiHeaderNode.reference_id)
  }

  get referenceGenericModelType(): GenericType {
    return ModelType.Text
  }

  get referenceModelType(): ModelType {
    return this.referenceGenericModelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision = !node // nothing can be linked to it - end of the line
    this.debugCanLinkTo('ApiHeaderPathService', this.apiHeaderNode, node, decision)
    return decision
  }

  get referenceIsCollection(): boolean {
    return false
  }
}